/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFilesMode: {
  name: 'files-mode';
  data: string;
} = {
  name: 'files-mode',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 .5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 0-1H3.5v-4H11a.5.5 0 0 0 0-1H3.5v-4H9a.5.5 0 0 0 0-1H3.5v-3H7a.5.5 0 0 0 0-1H3Z" fill="currentColor"/></svg>`,
};
